import {gsap} from "gsap";

const {ScrollTrigger} = require('gsap/ScrollTrigger.js');

document.addEventListener('DOMContentLoaded', () => {
	gsap.registerPlugin(ScrollTrigger);
	gsap.to('.slider .content-area', {
		scrollTrigger: {
			trigger: '.slider',
			start: '60% 50%',
			scrub: true,
		},
		yPercent: '100',
		scale: 0,
		opacity: 0,
	});

	const specialImagesSlider = document.querySelectorAll('.special-image-container .image-area');
	if(specialImagesSlider) {
		specialImagesSlider.forEach((el) => {
			gsap.to(el, {
				scrollTrigger: {
					trigger: '.slider',
					start: '60% 50%',
					scrub: true,
				},
				yPercent: '100',
				scale: 0,
				opacity: 0,
			});
		});
	}

	gsap.from('.product1', {
		scrollTrigger: {
			trigger: '.products',
			start: '10% bottom',
			end: '+=400px',
			scrub: true,
		},
		xPercent: '-110',
	});

	gsap.from('.image-product1', {
		scrollTrigger: {
			trigger: '.products',
			start: '10% bottom',
			end: '+=400px',
			scrub: true,
		},
		xPercent: '110',
	});

	const product2 = document.querySelector('.products .product2');
	if(product2) {
		gsap.from(product2, {
			scrollTrigger: {
				trigger: '.products',
				start: `${product2.offsetTop} bottom`,
				end: '+=600px',
				scrub: true,
			},
			yPercent: '110',
		});
	}

	const productImage2 = document.querySelector('.products .image-product2');

	if(productImage2) {
		gsap.from(productImage2, {
			scrollTrigger: {
				trigger: '.products',
				start: `${productImage2.offsetTop} bottom`,
				end: '+=600px',
				scrub: true,
			},
			yPercent: '-110',
		});
	}

	const product3 = document.querySelector('.products .product3');
	if(product3) {
		let precent = '-110';

		if(window.innerWidth < 567) {
			precent = '100';
		}

		gsap.from(product3, {
			scrollTrigger: {
				trigger: '.products',
				start: `${product3.offsetTop} bottom`,
				end: '+=600px',
				scrub: true,
			},
			yPercent: precent,
		});
	}

	const product4 = document.querySelector('.products .product4');
	if(product4) {
		gsap.from(product4, {
			scrollTrigger: {
				trigger: '.products',
				start: `${product4.offsetTop} bottom`,
				end: '+=600px',
				scrub: true,
			},
			yPercent: '100',
		});
	}

	const gtaFrom = document.querySelector('.page-home--gta form');
	const contentForm = document.querySelector('.page-home--gta .content-area');
	if(gtaFrom && contentForm) {
		gsap.from(gtaFrom, {
			scrollTrigger: {
				trigger: '.page-home--gta',
				start: `-100px bottom`,
				end: '+=600px',
				scrub: true,
			},
			xPercent: '-100'
		});

		gsap.from(contentForm, {
			scrollTrigger: {
				trigger: '.page-home--gta',
				start: `-100px bottom`,
				end: '+=600px',
				scrub: true,
			},
			opacity: '0'
		});
	}

	if(window.innerWidth >= 992) {
		let tl = gsap.timeline();
		tl.from('.page-home--gta .man-gta', {xPercent: '-100', yPercent: '-100', rotate: '-180deg'});
		tl.from('.page-home--gta .section-title', {opacity: 0, translateY: '-100%'});

		ScrollTrigger.create({
			animation: tl,
			trigger: '.page-home--gta',
			start: '100px 30%',
			end: '+=600px',
			scrub: true,
			pin: true,
		});
	} else {
		gsap.from('.page-home--gta .section-title', {
			scrollTrigger: {
				trigger: '.page-home--gta',
				start: 'top bottom',
				end: '+=600px',
				scrub: true,
			},
			opacity: 0, translateY: '-100%'
		});
	}

	gsap.from('.page-home--about', {
		scrollTrigger: {
			trigger: '.page-home--about',
			start: `-200px bottom`,
			end: '+=600px',
			scrub: true,
		},
		scale: '0'
	});

	const advantagesTitle = document.querySelector('.page-home--advantages .title-area');
	if(advantagesTitle) {
		gsap.from(advantagesTitle, {
			scrollTrigger: {
				trigger: '.page-home--advantages',
				start: `top bottom`,
				end: '+=400px',
				scrub: true,
			},
			scale: 0,
			opacity: 0,
			xPercent: '-100'
		});

		const contentAdvantages = document.querySelectorAll('.page-home--advantages .content-area');
		if(contentAdvantages) {
			contentAdvantages.forEach((el) => {
				gsap.from(el, {
					scrollTrigger: {
						trigger: '.page-home--advantages',
						start: `${advantagesTitle.offsetHeight + 100} bottom`,
						end: '+=600px',
						scrub: true,
					},
					scale: 0,
					opacity: 0,
					xPercent: '100'
				})
			});
		}
	}

	const contentInfoblock = document.querySelectorAll('.page-home--infoblock .content-area');
	if(contentInfoblock) {
		contentInfoblock.forEach((el) => {
			gsap.from(el, {
				scrollTrigger: {
					trigger: '.page-home--infoblock',
					start: `200 bottom`,
					end: '+=600px',
					scrub: true,
				},
				yPercent: '-100'
			})
		});
	}

	if(window.innerWidth > 567) {
		gsap.from('.page-home--gta2 .container-gta', {
			scrollTrigger: {
				trigger: '.page-home--gta2',
				start: `200 bottom`,
				end: '+=400px',
				scrub: true,
			},
			yPercent: '-120'
		});
	} else {
		gsap.from('.page-home--gta2 .container-gta', {
			scrollTrigger: {
				trigger: '.page-home--gta2',
				start: `top bottom`,
				end: '+=600px',
				scrub: true,
			},
			yPercent: '-120'
		});
	}

	gsap.from('.page-home--gta2 .man-left', {
		scrollTrigger: {
			trigger: '.page-home--gta2',
			start: `200 bottom`,
			end: '+=600px',
			scrub: true,
		},
		xPercent: '-120'
	});

	gsap.from('.page-home--gta2 .man-right', {
		scrollTrigger: {
			trigger: '.page-home--gta2',
			start: `-100px bottom`,
			end: '+=600px',
			scrub: true,
		},
		xPercent: '120'
	});

	gsap.from('.page-home--contacts .image-area', {
		scrollTrigger: {
			trigger: '.page-home--contacts',
			start: `-100px bottom`,
			end: '+=600px',
			scrub: true,
		},
		xPercent: '-120'
	});

	gsap.from('.page-home--contacts .content-wrapper', {
		scrollTrigger: {
			trigger: '.page-home--contacts',
			start: `-100px bottom`,
			end: '+=600px',
			scrub: true,
		},
		xPercent: '120'
	})

});